<template>
  <p class="compliance-text">
    RiseUp Moments UK LTD is acting as an agent of TrueLayer,
    who is providing the regulated Account Information Service,
    and is Authorised and Regulated by the Financial Conduct Authority under
    the Payment Services Regulations 2017 and the Electronic Money Regulations
    2011 (Firm Reference Number: 901096)
  </p>
</template>

<style scoped lang="scss">
.compliance-text {
  color: rgba(0, 0, 0, 0.48);
  font-size: 12px;
  font-family: CircularStdBook;
  font-weight: 450;
  line-height: 18px;
  word-wrap: break-word;
  text-align: left;
  width: 90%;
  margin: 20px auto;
}
</style>
